// extracted by mini-css-extract-plugin
export default {"accomudationList":"Accomudation_accomudationList__5tqx5","accommodation-div":"Accomudation_accommodation-div__9yh+2"};